export enum ROLES {
    APPLICATION_ADMINISTRATOR = 'application_administrator',
    AUTHENTICATED = 'authenticated',
    CONCIERGE = "concierge",
}
